<template>
  <div>
    <el-card>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
          >Panel</el-breadcrumb-item
        >
        <el-breadcrumb-item>Gestor de usuarios</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <br />
    <el-card>
      <app-table-paginate
        v-if="getListUser.length > 0"
        :routeEdit="routeEdit"
        :tableQuery="getListUser"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="true"
      >
      </app-table-paginate>
      <br />
      <el-button type="primary" size="medium" @click="nuevoRegistro()"
        >Añadir usuario<i class="el-icon-circle-plus-outline el-icon-right"></i
      ></el-button>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

export default {
  name: "gestor-usuarios",
  components: {
    "app-table-paginate": tablaConPaginador,
  },
  async created() {
    this.routeEdit = "/dashboard/" + this.$route.params.db + "/usuarios/editar/";
    await this.getUsers();

    this.$root.$on("delete", (id) => {
      this.eliminarRegistro(id);
    });
  },
  beforeDestroy() {
    this.$root.$off("delete", (id) => {
      this.eliminarRegistro(id);
    });
  },
  data() {
    return {
      usersAPI: false,
      tableColumns: [
        {
          prop: "id",
          label: "#Id",
        },
        {
          prop: "user",
          label: "Usuario",
        },
        {
          prop: "level",
          label: "Permiso",
        },
      ],
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      limit: 50,
    };
  },
  methods: {
    async getUsers() {
      await ApiService.post("admin/users", {
        token: localStorage.getItem("token"),
        project: localStorage.getItem("table"),
      }).then((response) => {
        this.usersAPI = response.data;
      });
    },
    async eliminarRegistro(id) {
      this.usersAPI = [];
      await ApiService.post("admin/delete-user", {
        token: localStorage.getItem("token"),
        id: id,
      }).then((response) => {
        this.deleterow = response.data;
        if (this.deleterow == 1) {
          this.$message({ type: "success", message: "Se ha eliminado correctamente" });
          this.getUsers();
        } else {
          this.$message({ type: "warning", message: this.deleterow });
        }
      });
    },
    nuevoRegistro() {
      this.$router.push("/dashboard/" + this.$route.params.db + "/usuarios/nuevo");
    },
  },
  computed: {
    getListUser() {
      return this.usersAPI;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/usuarios.vue